import React from "react";
import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import auth from "./firebase";
import Loading from "./Pages/Loading";

 function PrivateRoutes() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {

const session = sessionStorage.getItem('token')
  if(!session){
    //
     // let data = JSON.parse(sessionStorage.getItem('token'))
     // setToken(data)
     return (window.location.href = "/")
    }else{
      setLoading(false)
     // 
    }
   

    
  }, [])


  return <> {loading ? <Loading /> : <Outlet />}</>;
}

export default PrivateRoutes;
